<div [class]="'messages ' + class + ' ' + show" (click)="hide_message()" [ngStyle]="style">
  <div>
    {{message}}
  </div>
</div>
